let authRun = ($rootScope, $state, $window, OAuth, OAuthToken, sharedService, cacheService) => {
    "ngInject";

    $rootScope.$on('oauth:error', function (event, rejection) {

        // Ignore `invalid_grant` error - should be catched on `LoginController`.
        if ('invalid_grant' === rejection.data.error && 400 === rejection.status && 
            ($state.is('auth.login') || $state.is('onTheBeach.login'))) {
            return;
        }

        // Refresh token on any 401 (expired JWT).
        // The backend returns {"code":401,"message":"Unauthorized"} — not the OAuth2
        // {"error":"invalid_token"} format — so we match on status code.
        if (401 === rejection.status) {
            if (sharedService.refreshingToken) {
                return;
            }
            sharedService.refreshingToken = true;
            return OAuth.getRefreshToken().then(() => {
                sharedService.refreshingToken = false;
                $state.reload('home');
            }, () => {
                sharedService.refreshingToken = false;
                OAuthToken.removeToken();
                const currentState = $state.current.name;
                const targetState = currentState.includes('onTheBeach') ? 'onTheBeach.login' : 'auth.login';
                $state.go(targetState);
            });
        }

        // Redirect to the same login page with the `error_reason`.
        const currentState = $state.current.name;
        const targetState = currentState.includes('onTheBeach') ? 'onTheBeach.login' : 'auth.login';
        $state.go(targetState, {
            'error_reason': rejection.data.error
        });
        event.preventDefault();
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        const unauthenticatedStates = ['auth.login', 'onTheBeach.login', 'old_goldupgrade', 'tab_name'];
        const onTheBeachBooking = cacheService.get('onTheBeachBooking') === true;
        const bookingReference = cacheService.get('bookingReference');
        const agencyBookingReference = cacheService.get('agencyBookingReference');

        if (OAuth.isAuthenticated()) {
            if (toState.name === 'onTheBeach.login') {
                if (onTheBeachBooking && agencyBookingReference) {
                    const language = toParams.locale || fromParams.locale;
                    $state.go('onTheBeach.booking.view', { locale: language });
                    event.preventDefault();
                }
            } else if (toState.name === 'auth.login') {
                if (!onTheBeachBooking && bookingReference) {
                    const language = toParams.locale || fromParams.locale;
                    $state.go('bookings.booking.view', { locale: language, bookingReference: bookingReference });
                    event.preventDefault();
                }
            }
        }
        else {
            // User isn't authenticated
            if (toState.name === 'tab_name' && toParams.tab === undefined) {
                $state.go('auth.login');
                event.preventDefault();
            } else if (unauthenticatedStates.indexOf(toState.name) === -1) {
                const area = toState.name.startsWith('onTheBeach') ? 'onTheBeach' : 'auth';
                $state.go(`${area}.login`);
                event.preventDefault();
            }
        }
    });
};

export default authRun;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.run.js